import { Layout } from 'antd'
import { DocumentList } from '../../components/Documents/DocumentList'
import { Navigation } from '../../components/Navigation/Navigation'
import { usePageTitle } from '../../utils/pageTitle'

const { Content } = Layout

export const DocumentsPage = () => {
  usePageTitle('Documents')
  return (
    <Layout className="min-h-screen">
      <Navigation />
      <Content className="p-6">
        <DocumentList />
      </Content>
    </Layout>
  )
}
